/* React */
import React from "react";

/* React-Redux */
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";

/* Components */
import PrimaryButton from "src/components/shared/buttons/primary-button/PrimaryButton";

const Google: React.FC = () => {
  const providerState = useSelector(
    (state: RootState) => state.provider
  );

  const { data } = providerState;

  /**
   * loginWithRedirect is directing the user to the
   * authentication page of Google. After user is authenticated,
   * the user is redirected to the redirectUri. This process is safer
   * than using a popup window.
   */
  const loginWithRedirect = () => {
    const clientId = data?.google.clientId;
    const scope = encodeURIComponent("profile email");
    const responseType = "token";

    const url =
      `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${clientId}&` +
      `redirect_uri=${data?.google.redirectUri}&` +
      `response_type=${responseType}&` +
      `scope=${scope}`;

    window.location.href = url;
  };

  return (
    <PrimaryButton
      testId={"google-btn"}
      scssProps={{
        color: "var(--ion-color-text-primary)",
        backgroundColor: "var(--ion-background-secondary)",
      }}
      type={"button"}
      ariaLabel={"Google"}
      icon={"/assets/icons/google.svg"}
      label={"Google"}
      onClick={loginWithRedirect}
    />
  );
};

export default Google;
